<template>
  <div>
    <div v-if="loading">loading...</div>
    <div v-if="!loading" class="table-responsive">
      <table class="table table-sm text-nowrap">
        <tr>
          <th>ID</th>
          <th>仕事ID</th>
          <th>ユーザーID</th>
          <th>応募日時</th>
        </tr>
        <tr v-for="(jobApply, index) in this.jobApplies" :key="index">
          <td>{{ jobApply.id }}</td>
          <td>{{ jobApply.jobId }}</td>
          <td>{{ jobApply.userId }}</td>
          <td>{{ jobApply.applyAt }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import master from '@/constants/MasterEnum'
import firebase from 'firebase'
import utils from '@/utils/Utils'

export default {
  name : "jobApplyInfo",
  mixins: [
    utils,
    master
  ],
  data () {
    return {
      loading : false,
      db : firebase.firestore(),
      jobApplies : [],
    }
  },
  props : {
    firstDate : {
      type : Date,
      required : true,
    },
    lastDate : {
      type : Date,
      required : true,
    }
  },
  created: function() {
    this.loading = true;
      this.db.collection("job_apply_histories")
      .orderBy('applied_at', 'asc')
      .startAt(this.firstDate)
      .endAt(this.lastDate)
      .get()
      .then((query) => {
        query.forEach((doc) => {
          var data = doc.data();
          this.jobApplies.push({
            id : doc.id,
            jobId : this.escapeNull(data.job_id),
            userId : this.escapeNull(data.user_id),
            applyAt : this.formatDateTime((data.applied_at).toDate()),
          });
        });
      })
      .then(() => {
        this.loading = false;
        this.$emit('bind-event' , this.jobApplies , this.tsvFormat.jobApplyInfo.fileName, this.tsvFormat.jobApplyInfo.labels)
      });
  }

}
</script>
